import React from 'react';
import {editCompanyReminderConfigs} from "../../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import ChoiceButtons from "../../../../../../../../components-new/form/ChoiceButtons";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";
import Switch from "../../../../../../../../components-new/form/Switch";
import colors from "../../../../../../../../utils/Colors";

const ReminderSettings = ({features, client, user, reminderData, setReminderData, isFetching}) => {

    const handleReminderDataChange = (e) => {
        const {name, value} = e.target;
        const updatedData = {
            ...reminderData,
            [name]: value
        };

        const isIntervalValid = updatedData.interval >= 10 && updatedData.interval <= 1000;
        const isCountValid = updatedData.count >= 0 && updatedData.count <= 10;

        setReminderData(updatedData);
        if (isIntervalValid && isCountValid) {
            editCompanyReminderConfigs(client.id, updatedData);
        }
    };

    // one option, and that is the whole list: ChoiceButtons prints it as the value
    // it is rather than as a choice of one, which is what the dropdown here was
    const typeOptions = [
        {
            value: "FROM_HARDCODED_MESSAGES",
            label: t({text: "reminderText", user})
        }
    ];

    const handleTypeChange = (value) => {
        handleReminderDataChange({
            target: {
                name: "type",
                value: value,
                type: "text"
            }
        });
    };

    const locked = !reminderData.enabled || isFetching;

    return (
        <SettingCard
            titleKey="reminderSettings"
            toggle={
                <Switch
                    checked={reminderData.enabled}
                    onChange={e => handleReminderDataChange({target: {value: e, name: 'enabled'}})}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            <div className={'setting-body setting-body--compact'
                + (!reminderData.enabled ? ' setting-body--off' : '')}>
                <label className="setting-field">
                    <span className="setting-label"><Translate text={'message'}/></span>

                    <ChoiceButtons
                        value={reminderData.type || 'FROM_HARDCODED_MESSAGES'}
                        options={typeOptions}
                        onChange={handleTypeChange}
                        disabled={locked}
                    />
                </label>

                <label className="setting-field">
                    <span className="setting-label"><Translate text="interval"/></span>

                    <div className="setting-number">
                        <div className="setting-number__box">
                            <Input
                                type="number"
                                name="interval"
                                value={reminderData.interval}
                                style={{width: '100%', border: 'none', height: '38px', background: 'transparent'}}
                                onChange={handleReminderDataChange}
                                min={10}
                                disabled={locked}
                            />
                        </div>
                        <span className="setting-number__unit"><Translate text={'sec'}/></span>
                    </div>
                </label>

                <label className="setting-field">
                    <span className="setting-label"><Translate text={'count'}/></span>

                    <div className="setting-number">
                        <div className="setting-number__box">
                            <Input
                                type="number"
                                name="count"
                                value={reminderData.count}
                                style={{width: '100%', border: 'none', height: '38px', background: 'transparent'}}
                                onChange={handleReminderDataChange}
                                max={10}
                                min={0}
                                disabled={locked}
                            />
                        </div>
                    </div>
                </label>
            </div>
        </SettingCard>
    );
};

export default ReminderSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/ReminderSettings.jsx